<template>
  <component :is="tag" class="rating-stars">
    <span
      v-for="i in 2"
      :key="i"
      :class="`rating-stars__${i === 1 ? 'blank' : 'filled'} u-decor`"
      :style="{ maxWidth: i === 1 ? undefined : maxWidth }"
    >
      <span
        v-for="n in total"
        :key="n"
        class="rating-stars__star u-fill-deep-current"
      >
        <svg-inline tag="span">
          <icon icon="star" />
        </svg-inline>
      </span>
    </span>
  </component>
</template>

<script>
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

export default {
  components: {
    SvgInline,
    Icon,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    value: {
      type: [String, Number],
      default: 0,
    },
    total: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    maxWidth() {
      return `${(+this.value / this.total) * 100}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.rating-stars {
  display: inline-flex;
  vertical-align: top;
  position: relative;

  &__blank,
  &__filled {
    display: flex;
    align-items: center;
  }

  &__blank {
    color: var.$gray-dark;
  }

  &__filled {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    color: var.$green-main;
    overflow: hidden;
  }

  &__star {
    flex-shrink: 0;
    width: 18px;
  }
}
</style>
